import ReactDOM from 'react-dom';
import {useState, useEffect} from 'react';

const defaultRoot = document.body;
/**
 * 將当前的组件放置于指定元素下面  默认body
 * @param [root] 外层元素
 * @param children
 * @return {{children, implementation, containerInfo, $$typeof, key}}
 * @constructor
 */
export const Portals = ({root, children = []}) => {
    const [el, sRoot] = useState(root ? null : defaultRoot);
    useEffect(() => {
        if (root) {
            root(sRoot)
        }
    }, []);
    return el ? ReactDOM.createPortal(
        children,
        el
    ) : null
};
